<template>
    <popup :opened="dataToShow" @close="close">
        <!-- BEGIN Content modal add referent -->
        <div>
            <div class="my-5 mx-5 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32">
                <h3 class="mb-10 text-pink-600">CV complété !</h3>
                <h6 class="text-indigo-600 mb-5">Vous pouvez dès à présent télécharger votre CV au format PDF.</h6>
                <h6 class="text-indigo-600 mb-10">Nous vous souhaitons pleine réussite dans votre recherche d'emploi/stage ou de formation.</h6>

                <div class="flex justify-center mb-10">
                    <illustration name="basket" />
                </div>

                <div class="flex justify-center">
                    <action-button
                        border-color="border-transparent"
                        text-color="text-white"
                        bg-color="bg-pink-600"
                        bg-color-square="bg-pink-600"
                        icon-color="text-white"
                        :uppercase="true"
                        libelle="Télécharger mon CV en PDF"
                        type-shadow="shadow-pink"
                        @clickAction="downloadPDF()"
                    />
                </div>
            </div>
        </div>
        <!-- END Content modal add referent -->
    </popup>
</template>

<script>
import Popup from './../../../components/Popup';
import ActionButton from './../../../components/ActionButton';
import Icon from './../../../components/Icon';
import Illustration from './../../../components/Illustration.vue';

export default {
  name:'DownloadCvPopup',

  props:{
    dataToShow: Boolean,
  },

  data() {
    return {
      //
    };
  },

  components:{
    Popup,
    ActionButton,
    Icon,
    Illustration
  },

  computed:{
    //
  },

  methods:{

    close(){
      this.$emit('close');
    },

    downloadPDF(){
      this.$emit('downloadPDF');
    },
  }
};
</script>
